import { render } from "./ProjectsApartmentsCard.vue?vue&type=template&id=55182a42"
import script from "./ProjectsApartmentsCard.vue?vue&type=script&lang=js"
export * from "./ProjectsApartmentsCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__